import { z } from 'zod';
import { zStringRequired } from '../../z';
import { registry } from '../registry';
const yesNoOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' },
];
export const baseOTSupervisory = z.object({
    onSiteVisit: zStringRequired().register(registry, {
        label: "Supervisory visit conducted in patient's home (on-site)",
        options: yesNoOptions,
    }),
    maintainsOpenCommunication: zStringRequired().register(registry, {
        label: 'Maintains an open communication process with the patient, representative (if any), caregivers, and family',
        options: yesNoOptions,
    }),
    arrivesAsScheduled: zStringRequired().register(registry, {
        label: 'Arrives for assigned visits as scheduled',
        options: yesNoOptions,
    }),
    followsPlanOfCare: zStringRequired().register(registry, {
        label: "Follows the patient's plan of care for completion of tasks as assigned",
        options: yesNoOptions,
    }),
    goalProgress: zStringRequired().register(registry, {
        label: 'Patient progress toward plan of care goals',
        options: [
            { value: 'on-track', label: 'On Track' },
            { value: 'partial', label: 'Partial' },
            { value: 'not-progressing', label: 'Not Progressing' },
        ],
    }),
    demonstratesCompetency: zStringRequired().register(registry, {
        label: 'Demonstrates competency with assigned tasks',
        options: yesNoOptions,
    }),
    informsSupervisor: zStringRequired().register(registry, {
        label: "Informs supervisor of patient's needs and changes in the patient's condition as required",
        options: yesNoOptions,
    }),
    compliesWithInfectionControl: zStringRequired().register(registry, {
        label: 'Complies with infection prevention and control policies and procedures',
        options: yesNoOptions,
    }),
    honorsClientRights: zStringRequired().register(registry, { label: "Honors patient's rights", options: yesNoOptions }),
    changesMadeToPlanOfCare: zStringRequired().register(registry, {
        label: "Changes made to patient's plan of care",
        options: yesNoOptions,
    }),
    deficiencyIdentified: zStringRequired().register(registry, {
        label: 'Deficiency in therapy services identified with need for competency evaluation',
        options: yesNoOptions,
    }),
    correctiveAction: z.string().optional().register(registry, { label: 'Corrective action / instruction given to OTA' }),
    comments: z.string().optional().register(registry, { label: 'Comments' }),
});
export const otSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: baseOTSupervisory.superRefine((data, ctx) => {
            if (data.deficiencyIdentified === 'yes' && !data.correctiveAction?.trim()) {
                ctx.addIssue({
                    path: ['correctiveAction'],
                    code: z.ZodIssueCode.custom,
                    message: 'required',
                });
            }
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
